import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { AnnouncementWarning } from '@/components/AnnouncementWarning';
import { CenteredPageContent } from '@/components/CenteredPageContent';
import { Column, Row } from '@/components/Grid';
import { MainContent } from '@/components/MainContent';
import { PageHeading } from '@/components/PageHeading';
import { WithGap } from '@/components/WithGap';
import { demoOrganizationCmId } from '@/demoMode/demoOrganizationCmId';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const DemoModePage: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <CenteredPageContent data-test="demo-mode-start-page">
      <AnnouncementWarning />

      <MainContent>
        <Row>
          <Column $span={6}>
            <WithGap gap="48">
              <PageHeading header={texts.pages.demo.title} />
              <p>{texts.pages.demo.description}</p>

              <div>
                <Button
                  as="a"
                  href={`/${demoOrganizationCmId}`}
                  iconRight="arrow_right"
                  data-trackid={getTrackId(
                    'go-to-demo-organization',
                    TrackingElement.Link,
                  )}
                >
                  {texts.pages.demo.goToConnect}
                </Button>
              </div>
            </WithGap>
          </Column>

          <StyledColumn $span={6}>
            <img
              alt="Profitable sustainability illustration"
              src={`${window.config.storeblocksAssetsBaseUrl}/illustrations/profitable-sustainability.svg`}
              height="300"
            />
          </StyledColumn>
        </Row>
      </MainContent>
    </CenteredPageContent>
  );
};

const StyledColumn = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
